import { createSelector } from 'reselect';

const adSlotSelector = state => state.slot;
const firmSelector = state => state.firm;
const listingSelector = state => state.listing;

// AD SLOTS
export const slots = createSelector(adSlotSelector, state => state.slots);
export const currentAdSlot = createSelector(adSlotSelector, state => state.current);
export const slotItemsForFirms = createSelector(adSlotSelector, state => state.items);
export const slotQuery = createSelector(adSlotSelector, state => state.query);
export const slotPage = createSelector(adSlotSelector, state => state.activePage);
export const slotPageCount = createSelector(adSlotSelector, state => state.count);

// FIRMS
export const firms = createSelector(firmSelector, state => state.firms);
export const repOptionsForFirm = createSelector(firmSelector, state => state.repOptions);
export const firmOptions = createSelector(firmSelector, state => state.firmOptions);
export const currentFirm = createSelector(firmSelector, state => state.current);

// LISTINGS
export const listings = createSelector(listingSelector, state => state.listings);
export const currentListing = createSelector(listingSelector, state => state.current);
export const typeOptions = createSelector(listingSelector, state => state.typeOptions);
